<script>
import {
    eventGroupState, isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { createEventDispatcher } from 'svelte';
import { toast } from '@zerodevx/svelte-toast';
import * as m from "@app/paraglide/messages.js";
const dispatch = createEventDispatcher();

const TRACK_LETTERS = ["A", "B", "C", "D"];

let isLocked = $derived(isSelectedEventGroupLocked());
let isDisabled = $derived(
    isLocked ||
    eventGroupState.length === 0 ||
    eventGroupState[projectState.selected]?.selected.length === 0
);

function assignTrack(track) {
    try {
        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        eventGroupState[projectState.selected].selected.forEach(selectedEventIndex => {
            eventGroupState[projectState.selected].events[selectedEventIndex].track = track;
        });

        insertHistoryAction({
            name: "update event track", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally {
        dispatch("done");
    }
}
</script>

<div id="btnEventTrack"
    class="dropdown-item d-flex align-items-center justify-content-between gap-2"
    class:disabled={isDisabled}
    role="menuitem"
    aria-label={m.context_menu_event_track_label()}
    aria-disabled={isDisabled}>
    <span>{m.context_menu_event_track()}</span>
    <div class="btn-group btn-group-sm" role="group">
        <button type="button"
            class="btn btn-outline-secondary"
            title={m.event_track_none()}
            disabled={isDisabled}
            onclick={() => assignTrack(false)}>
            &mdash;
        </button>
        {#each TRACK_LETTERS as letter (letter)}
            <button type="button"
                class="btn btn-outline-secondary"
                title="{m.multiview_track()} {letter}"
                disabled={isDisabled}
                onclick={() => assignTrack(letter)}>
                {letter}
            </button>
        {/each}
    </div>
</div>
